<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>企业类型：</span>
        <span>{{ item.enterpriseType | dictFilter(enterpriseTypeDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>联系人：</span>
        <span>{{ item.linkMan }}</span>
      </van-row>
      <van-row>
        <span>联系方式：</span>
        <span>{{ item.mobilePhone }}</span>
      </van-row>
      <van-row>
        <span>电子邮箱：</span>
        <span>{{ item.email }}</span>
      </van-row>
      <van-row>
        <span>办公地址：</span>
        <span>{{ item.officeAddress }}</span>
      </van-row>
      <van-row>
        <span>成立时间：</span>
        <span>{{ item.establishDate }}</span>
      </van-row>
      <van-row>
        <span>报价响应：</span>
        <span>{{ item.quoteStatus | dictFilter(quoteStatusDictOptions) }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  data() {
    return {}
  },
  props: {
    detailsList: {
      type: Array,
      required: true
    }
  },
  computed: {
    enterpriseTypeDictOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    quoteStatusDictOptions() {
      return this.$store.getters.dicts.quote_status
    }
  }
}
</script>
